import Headers from "@/component/Headers";
import { geNotifications, geNotificationsHide, geNotificationsUnreadCount } from '@/Redux/futures/notification/actions';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch } from 'react-redux';
import imgImage521 from "../../../assets/web-v3-images/2b95eabc35cc72be0b91a0d1a96588f6c6943ed4.png";
import ellipse from "../../../assets/web-v3-images/Ellipse_30.png";
import IMG_LP_WALLET from "@assets/web-v3-images/icons/crown-coin-icon.png";
import imgNoData from "@assets/web-v3-images/img-nodata.png";
import IMG_TURN_WALLET from "@assets/web-v3-images/icons/puzzlex5.png";
import imgShwePuzzle from "@assets/web-v3-images/icons/shwe-puzzle-icon.png";
import imgShweVault from "@assets/web-v3-images/icons/shwe-vault-icon.png";
import img_USER_RANK from "@assets/web-v3-images/icons/badge-master.png";
import img_DAILY_PRIZE from "@assets/web-v3-images/image 641.png";
import IMG_LOGIN_STREAK from "@assets/web-v3-images/icons/shwe-journal-icon.png";
import IMG_SHWE_PUZZLE from "@assets/web-v3-images/icons/shwe-hour-coin.png";
import img_bg from "@assets/web-v3-images/4bbe745a0b83d3fffa3aed171a82fd6afb698c43.png";
import imageBgButton from "@assets/web-v3-images/btn-buy.png";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useNavigate } from 'react-router';

dayjs.extend(relativeTime);

const ICON_MAP = {
  'LP_WALLET': IMG_LP_WALLET,
  "TURN_WALLET": IMG_TURN_WALLET,
  // "DAILY_PRIZE": imgShweVault,
  'LOGIN_STREAK': IMG_LOGIN_STREAK,
  'SHWE_PUZZLE': IMG_SHWE_PUZZLE,
  'SHWE_VAULT': imgShweVault,
  'DAILY_PRIZE_REMINDER': img_DAILY_PRIZE,
  'USER_RANK': img_USER_RANK,
};

const BUTTON_LABEL_MAP = {
  'LP_WALLET': 'notification.withdraw',
  'TURN_WALLET': 'notification.buy',
  'LOGIN_STREAK': 'notification.claim',
  'SHWE_PUZZLE': 'notification.play',
  'DAILY_PRIZE': 'notification.view_lp',
};

function Header() {
  const { t } = useTranslation();
  return (
    <Headers
      title={t("pages.notification")}
      className="absolute left-0 top-[110.29px] w-[880px] gap-[24px] px-[32px] py-[24px]"
    />
  );
}

// Giả lập 4 trang, mỗi trang 2 item, dựa trên format thật bạn đưa
const MOCK_DB = Array.from({ length: 80 }, (_, i) => ({
  key: 0,
  id: i + 1,
  trigger_source: i % 2 === 0 ? "DAILY_PRIZE" : "LP_WALLET",
  title_en: `Mock title en ${i + 1}`,
  title_my: `Mock title my ${i + 1}`,
  actor_name_masked: "Mint T***",
  image_url: "https://example.com/prize.png",
  target_route: i % 2 === 0 ? "/daily-prize" : "/loyalty-point",
  created_at: new Date(Date.now() - i * 60000).toISOString(),
  type: i % 2 === 0 ? "BROADCAST" : "ACTIONABLE",
  is_unread: i < 2,
  title: `Mock title en ${i + 1}`,
}));

const PAGE_SIZE = 20;
const TOTAL_PAGES = Math.ceil(MOCK_DB.length / PAGE_SIZE);

const mockGetNotifications = ({ query, callback }) => {
  const { page } = query;
  console.log("📡 [MOCK] Fetching page:", page);

  setTimeout(() => {
    const start = (page - 1) * PAGE_SIZE;
    const end = start + PAGE_SIZE;
    const items = MOCK_DB.slice(start, end);
    const hasMore = page < TOTAL_PAGES;

    callback({
      success: true,
      message: null,
      data: {
        items,
        total: MOCK_DB.length,
        has_more: hasMore,
      },
    });
  }, 600);
};


function BodyItem({ item, onRefresh }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isDailyPrize = item?.icon_key === 'DAILY_PRIZE';

  const getIcon = (iconKey) => {
    return ICON_MAP[iconKey];
  };

  const getButtonLabel = (iconKey) => {
    const key = BUTTON_LABEL_MAP[iconKey];
    return key ? t(key) : t('notification.claim');
  };

  const handleClick = () => {
    dispatch(geNotificationsHide({
      query: {
        type: item?.type,
        id: item?.id,
      },
    }));

    if (item?.target_route) {
      navigate(item.target_route);
    } else {
      onRefresh?.();
    }
  };

  const formatTimeAgo = (date, t) => {
    const now = dayjs();
    const time = dayjs(date);

    const minutes = now.diff(time, "minute");
    if (minutes <= 0) return t("notification.time.just_now");
    if (minutes < 60) {
      return t("notification.time.minute_ago", { value: minutes });
    }

    const hours = now.diff(time, "hour");
    if (hours < 24) {
      return t("notification.time.hour_ago", { value: hours });
    }

    const days = now.diff(time, "day");
    if (days < 30) {
      return t("notification.time.day_ago", { value: days });
    }

    const months = now.diff(time, "month");
    if (months < 12) {
      return t("notification.time.month_ago", { value: months });
    }

    const years = now.diff(time, "year");
    return t("notification.time.year_ago", { value: years });
  };

  return (
    <div
      className={`relative rounded-[28px] shrink-0 w-full ${isDailyPrize ? "" : "bg-[#fefbe8]"
        }`}
      onClick={handleClick}
    >
      {/* Nền: gradient cho DAILY_PRIZE, solid + border cho các loại còn lại */}
      {isDailyPrize ? (
        <div
          aria-hidden
          className="absolute inset-0 pointer-events-none rounded-[28px]"
          style={{
            backgroundImage:
              "linear-gradient(166.673deg, rgb(254, 226, 130) 21.535%, rgb(248, 128, 63) 100%)",
          }}
        />
      ) : (
        <div
          aria-hidden
          className="absolute border-3 border-[#ffb86c] border-solid inset-0 pointer-events-none rounded-[28px]"
        />
      )}

      <div className="flex flex-row items-center overflow-clip rounded-[inherit] size-full">
        <div className="content-stretch flex gap-[16px] items-center p-[32px] relative size-full">
          <div className="content-stretch flex flex-[1_0_0] gap-[16px] items-center min-w-px relative">
            <div className="relative shrink-0 size-[100px]" data-name="image 529">
              {isDailyPrize ? (
                <>
                  <div
                    className="-translate-x-1/2 -translate-y-1/2 absolute left-[calc(50%)] size-[254px] top-[calc(50%+3.57px)]"
                    data-name="image 487"
                  >
                    <img
                      alt=""
                      className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
                      src={img_bg}
                    />
                  </div>
                  {(item?.image_url || getIcon(item?.icon_key)) && (
                    <img
                      alt=""
                      className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 max-w-none pointer-events-none size-full"
                      src={item?.image_url || getIcon(item?.icon_key)}
                      onError={(e) => {
                        const fallback = getIcon(item?.icon_key);
                        if (fallback && !e.currentTarget.dataset.fallback) {
                          e.currentTarget.dataset.fallback = "1";
                          e.currentTarget.src = fallback;
                        } else {
                          e.currentTarget.style.display = "none";
                        }
                      }}
                    />
                  )}
                </>
              ) : (
                (item?.image_url || getIcon(item?.icon_key)) && (
                  <img
                    alt=""
                    className="absolute inset-0 max-w-none object-bottom pointer-events-none size-full"
                    src={item?.image_url || getIcon(item?.icon_key)}
                    onError={(e) => {
                      const fallback = getIcon(item?.icon_key);
                      if (fallback && !e.currentTarget.dataset.fallback) {
                        e.currentTarget.dataset.fallback = "1";
                        e.currentTarget.src = fallback;
                      } else {
                        e.currentTarget.style.display = "none";
                      }
                    }}
                  />
                )
              )}
            </div>

            <div className="[word-break:break-word] content-stretch flex flex-[1_0_0] flex-col gap-[12px] items-start min-w-px not-italic relative text-[28px] tracking-[0.28px]">
              <div className="flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] min-w-full relative shrink-0 text-[#772917] w-[min-content]">
                <p className="leading-[normal]">{item?.title}</p>
              </div>
              <p className="font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] whitespace-nowrap">
                {formatTimeAgo(item?.created_at, t)}
              </p>
            </div>
          </div>

          {/* <div className="relative w-[174px] shrink-0 btn-click-active" >
            {isDailyPrize ?
              <>
                <div class="w-[174px] h-[80px] rounded-full flex items-center justify-center border-2 border-transparent
                   [background:linear-gradient(166.673deg,#fff5e6_0%,#ffcb8e_100%)_padding-box,linear-gradient(rgba(255,255,255,1),rgba(252,228,191,1))_border-box]">
                  <p class="font-extrabold text-[28px] text-[#a15c07] whitespace-nowrap">
                    {getButtonLabel(item?.icon_key)}
                  </p>
                </div>
              </> :
              <>
                <img src={imageBgButton} alt="Group 1" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <p className="font-extrabold text-[28px] tracking-[0.28px] text-white whitespace-nowrap">
                    {getButtonLabel(item?.icon_key)}
                  </p>
                </div>
              </>}
          </div> */}

          {item?.is_unread && (
            <div className="absolute left-[775px] size-[24px] top-[16px]">
              <img src={ellipse} alt="Ellipse" />
            </div>
          )}
        </div>
      </div>

      {isDailyPrize && (
        <>
          <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_15px_0px_white]" />
          <div
            aria-hidden
            className="absolute border-3 border-[#fef6ee] border-solid inset-0 pointer-events-none rounded-[28px]"
          />
        </>
      )}
    </div>
  );
}

// function BodyItem5() {
//   return (
//     <div className="relative rounded-[28px] shrink-0 w-full">
//       <div
//         aria-hidden
//         className="absolute inset-0 pointer-events-none rounded-[28px]"
//         style={{
//           backgroundImage:
//             "linear-gradient(166.673deg, rgb(254, 226, 130) 21.535%, rgb(248, 128, 63) 100%)",
//         }}
//       />
//       <div className="flex flex-row items-center overflow-clip rounded-[inherit] size-full">
//         <div className="content-stretch flex gap-[16px] items-center p-[32px] relative size-full">
//           <div className="content-stretch flex gap-[16px] items-start relative shrink-0 w-[555px]">
//             <div className="relative shrink-0 size-[100px]">
//               <div
//                 className="-translate-x-1/2 -translate-y-1/2 absolute left-[calc(50%+13.5px)] size-[254px] top-[calc(50%+3.57px)]"
//                 data-name="image 487"
//               >
//                 <img
//                   alt=""
//                   className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
//                   src={img_bg}
//                 />
//               </div>
//             </div>
//             <div className="[word-break:break-word] content-stretch flex flex-[1_0_0] flex-col gap-[12px] items-start min-w-px not-italic relative text-[28px] tracking-[0.28px]">
//               <div className="flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] min-w-full relative shrink-0 text-[#772917] w-[min-content]">
//                 <p className="leading-[normal]">
//                   Mint Thant just won Fridge of minigame!
//                 </p>
//               </div>
//               <p className="font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] whitespace-nowrap">
//                 10m ago
//               </p>
//             </div>
//           </div>

//         </div>
//       </div>
//       <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_15px_0px_white]" />
//       <div
//         aria-hidden
//         className="absolute border-3 border-[#fef6ee] border-solid inset-0 pointer-events-none rounded-[28px]"
//       />
//     </div>
//   );
// }

// function BodyItem2() {
//   const { t } = useTranslation();
//   return (
//     <div className="bg-[#fefbe8] relative rounded-[28px] shrink-0 w-full">
//       <div
//         aria-hidden
//         className="absolute border-3 border-[#ffb86c] border-solid inset-0 pointer-events-none rounded-[28px]"
//       />
//       <div className="flex flex-row items-center size-full">
//         <div className="content-stretch flex gap-[16px] items-center p-[32px] relative size-full">
//           <div className="content-stretch flex flex-[1_0_0] gap-[16px] items-start min-w-px relative">
//             <div className="flex items-center justify-center relative shrink-0 size-[100.304px]">
//               <div className="-scale-y-100 flex-none rotate-[179.83deg]">
//                 <div className="relative size-[100px]" data-name="image 395">
//                   <img
//                     alt=""
//                     className="absolute block inset-0 max-w-none size-full"
//                     height="100"
//                     src={imgImage395}
//                     width="100"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="[word-break:break-word] content-stretch flex flex-[1_0_0] flex-col gap-[12px] items-start min-w-px not-italic relative text-[28px] tracking-[0.28px]">
//               <div className="flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] min-w-full relative shrink-0 text-[#772917] w-[min-content]">
//                 <p className="leading-[normal]">
//                   Your turn balance is low. Buy more to keep playing smooth
//                 </p>
//               </div>
//               <p className="font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] whitespace-nowrap">
//                 10m ago
//               </p>
//             </div>
//           </div>
//           <div className="content-stretch flex items-center relative shrink-0 w-[174px] btn-click-active">
//             <img src={imageBgButton} alt="" />
//             <div className="-translate-y-1/2 [word-break:break-word] absolute flex flex-col font-['Inter:Extra_Bold',sans-serif] font-extrabold justify-center leading-[0] left-[calc(50%-27px)] not-italic text-[28px] text-white top-[calc(50%-0.5px)] tracking-[0.28px] whitespace-nowrap">
//               <p className="leading-[normal]">
//                 {t("account_page.package.buy")}
//               </p>
//             </div>
//           </div>
//           <div className="absolute left-[775px] size-[24px] top-[16px]">
//             <img src={ellipse} alt="Ellipse" />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// function BodyItem3() {
//   const { t } = useTranslation();
//   return (
//     <div className="bg-[#fefbe8] relative rounded-[28px] shrink-0 w-full">
//       <div
//         aria-hidden
//         className="absolute border-3 border-[#ffb86c] border-solid inset-0 pointer-events-none rounded-[28px]"
//       />
//       <div className="flex flex-row items-center size-full">
//         <div className="content-stretch flex gap-[16px] items-center p-[32px] relative size-full">
//           <div className="content-stretch flex flex-[1_0_0] gap-[16px] items-start min-w-px relative">
//             <div className="overflow-clip relative shrink-0 size-[100px]">
//               <div
//                 className="absolute h-[219.671px] left-[-26.01px] top-[-40.89px] w-[519.027px]"
//                 data-name="image 441"
//               >
//                 <div className="absolute inset-[21.27%_6.59%_38.02%_5.29%]">
//                   <img
//                     alt=""
//                     className="block max-w-none size-full"
//                     height="89.435"
//                     src={imgImage441}
//                     width="457.348"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="[word-break:break-word] content-stretch flex flex-[1_0_0] flex-col gap-[12px] items-start min-w-px not-italic relative text-[28px] tracking-[0.28px]">
//               <div className="flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] min-w-full relative shrink-0 text-[#772917] w-[min-content]">
//                 <p className="leading-[normal]">{`Daily reward is ready. Don't miss it.`}</p>
//               </div>
//               <p className="font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] whitespace-nowrap">
//                 10m ago
//               </p>
//             </div>
//           </div>
//           <div className="content-stretch flex items-center relative shrink-0 w-[174px] btn-click-active">
//             <img src={imageBgButton} alt="" />
//             <div className="-translate-y-1/2 [word-break:break-word] absolute flex flex-col font-['Inter:Extra_Bold',sans-serif] font-extrabold justify-center leading-[0] left-[calc(50%-30px)] not-italic text-[28px] text-white top-[calc(50%-0.5px)] tracking-[0.28px] whitespace-nowrap">
//               <p className="leading-[normal]">{t("join")}</p>
//             </div>
//           </div>
//           <div className="absolute left-[775px] size-[24px] top-[16px]">
//             <img src={ellipse} alt="Ellipse" />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// function BodyItem4() {
//   const { t } = useTranslation();
//   return (
//     <div className="bg-[#fefbe8] relative rounded-[28px] shrink-0 w-full">
//       <div
//         aria-hidden
//         className="absolute border-3 border-[#ffb86c] border-solid inset-0 pointer-events-none rounded-[28px]"
//       />
//       <div className="flex flex-row items-center size-full">
//         <div className="content-stretch flex gap-[16px] items-center p-[32px] relative size-full">
//           <div className="content-stretch flex flex-[1_0_0] gap-[16px] items-start min-w-px relative">
//             <div className="overflow-clip relative shrink-0 size-[100px]">
//               <div
//                 className="absolute h-[219.671px] left-[-150px] top-[-40.89px] w-[519.027px]"
//                 data-name="image 441"
//               >
//                 <div className="absolute inset-[21.27%_6.59%_38.02%_5.29%]">
//                   <img
//                     alt=""
//                     className="block max-w-none size-full"
//                     height="89.435"
//                     src={imgImage441}
//                     width="457.348"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="[word-break:break-word] content-stretch flex flex-[1_0_0] flex-col gap-[12px] items-start min-w-px not-italic relative text-[28px] tracking-[0.28px]">
//               <div className="flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] min-w-full relative shrink-0 text-[#772917] w-[min-content]">
//                 <p className="leading-[normal]">Shwe Vault is ready to open</p>
//               </div>
//               <p className="font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] whitespace-nowrap">
//                 10m ago
//               </p>
//             </div>
//           </div>
//           <div className="content-stretch flex items-center relative shrink-0 w-[174px] btn-click-active">
//             <img src={imageBgButton} alt="" />
//             <div className="-translate-y-1/2 [word-break:break-word] absolute flex flex-col font-['Inter:Extra_Bold',sans-serif] font-extrabold justify-center leading-[0] left-[calc(50%-38px)] not-italic text-[28px] text-white top-[calc(50%-0.5px)] tracking-[0.28px] whitespace-nowrap">
//               <p className="leading-[normal]">{t("open")}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }



// function BodyItem6() {
//   return (
//     <div className="bg-[#fefbe8] relative rounded-[28px] shrink-0 w-full">
//       <div
//         aria-hidden
//         className="absolute border-3 border-[#ffb86c] border-solid inset-0 pointer-events-none rounded-[28px]"
//       />
//       <div className="flex flex-row items-center size-full">
//         <div className="content-stretch flex gap-[16px] items-center p-[32px] relative size-full">
//           <div className="content-stretch flex flex-[1_0_0] gap-[16px] items-start min-w-px relative">
//             <div className="overflow-clip relative shrink-0 size-[100px]">
//               <div
//                 className="absolute h-[219.671px] left-[-390px] top-[-40.89px] w-[519.027px]"
//                 data-name="image 441"
//               >
//                 <div className="absolute inset-[21.27%_6.59%_38.02%_5.29%]">
//                   <img
//                     alt=""
//                     className="block max-w-none size-full"
//                     height="89.435"
//                     src={imgImage441}
//                     width="457.348"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="[word-break:break-word] content-stretch flex flex-[1_0_0] flex-col gap-[12px] items-start min-w-px not-italic relative text-[28px] tracking-[0.28px]">
//               <div className="flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] min-w-full relative shrink-0 text-[#772917] w-[min-content]">
//                 <p className="leading-[normal]">
//                   You have 2 free coins in Shwe Puzzle!
//                 </p>
//               </div>
//               <p className="font-['Inter:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#a15c07] whitespace-nowrap">
//                 10m ago
//               </p>
//             </div>
//           </div>
//           <div className="content-stretch flex items-center relative shrink-0 w-[174px] btn-click-active">
//             <img src={imageBgButton} alt="" />
//             <div className="-translate-y-1/2 [word-break:break-word] absolute flex flex-col font-['Inter:Extra_Bold',sans-serif] font-extrabold justify-center leading-[0] left-[calc(50%-30px)] not-italic text-[28px] text-white top-1/2 tracking-[0.28px] whitespace-nowrap">
//               <p className="leading-[normal]">Play</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

function MainBody() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [dataResApi, setdataResApi] = useState(null);
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [hasFetched, setHasFetched] = useState(false);

  const containerRef = useRef(null);

  const afterNotifications = (data, isLoading) => {
    setLoading(false);
    setHasFetched(true);
    if (data?.success && data?.data) {
      const newItems = data.data.items ?? [];
      setItems((prev) =>
        page === 1 ? newItems : [...prev, ...newItems]
      );
      setHasMore(Boolean(data.data.has_more));
    }
  };

  const geNotificationsPage = (pageToFetch) => {
    setLoading(true);
    const body = {
      query: {
        page: pageToFetch,
      },
      callback: afterNotifications,
    };
    dispatch(geNotifications(body));
    // mockGetNotifications(body); test 
  };

  useEffect(() => {
    geNotificationsPage(page);
  }, [page]);

  const handleScroll = useCallback(() => {
    const el = containerRef.current;
    if (!el || loading || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = el;
    const nearBottom = scrollTop + clientHeight >= scrollHeight - 100;

    if (nearBottom) {
      setPage((prev) => prev + 1);
    }
  }, [loading, hasMore]);

  useEffect(() => {
    dispatch(geNotificationsUnreadCount({}));
  }, []);

  return (
    <div
      ref={containerRef}
      onScroll={handleScroll}
      className={`absolute content-stretch flex flex-col gap-[20px] items-start left-0 p-[32px] top-[254px] w-[879px]
     overflow-y-auto scrollbar-thin scrollbar-thumb-[#E6B97D] scrollbar-track-transparent cursor-pointer ${hasFetched && !loading && items?.length === 0 ? 'h-[1550px]' : 'max-h-[1550px]'
        }`}>
      {items?.length > 0 &&
        items.map((item, index) => (
          <BodyItem
            item={item}
            key={`${item?.id}-${index}`}
            onRefresh={() => geNotificationsPage(page)}
          />
        ))}

      {loading && (
        <div className="w-full text-center py-2 text-sm text-[#E6B97D]">
          {t("loading")}
        </div>
      )}

      {hasFetched && !loading && items?.length === 0 && (
        <div className='text-center w-full m-auto pb-30'>
          <img src={imgNoData} alt="no-data" className='w-full px-[17%] sm:px-[25%]' />
          <p className='text-[rgba(113,59,18,1)] text-[31px] font-bold pt-10'>{t('notification.no_notification_yet')}</p>
          <p className='text-[rgba(161,92,7,1)] text-[23px] font-medium pt-2'>{t('notification.your_notification_will_appear_here')}</p>
        </div>
      )}

      {/* {!hasMore && items.length > 0 && (
        <div className="w-full text-center py-2 text-xs text-gray-400">
          {t("no_more_notifications")}
        </div>
      )} */}
      {/* lấy cái đầu, những cái còn lại xóa được khi ghép data */}
      {/* <BodyItem /> */}
      {/* <BodyItem2 />
      <BodyItem3 />
      <BodyItem4 />
      <BodyItem5 />
      <BodyItem6 /> */}
    </div>
  );
}

export default function ComponentNotification() {
  return (
    <div
      className="bg-gradient-to-b from-[#fceed2] relative size-full to-[#fec790]"
      data-name="Thông báo"
    >
      <div
        className="-translate-x-1/2 absolute h-[520px] left-1/2 top-[-135px] w-[924px]"
        data-name="image 521"
      >
        <div aria-hidden className="absolute inset-0 pointer-events-none">
          <img
            alt=""
            className="absolute max-w-none object-cover size-full -mt-0.5"
            src={imgImage521}
          />
          <div className="absolute bg-gradient-to-b from-[65.577%] from-[rgba(252,232,199,0)] inset-0 to-[#fce8c7] to-[97.788%]" />
        </div>
      </div>
      <div className="mt-[-30px] sm:mt-[-70px]">
        <Header />
      </div>
      <MainBody />
    </div>
  );
}
